export default __webpack_public_path__ + "static/media/pants-short-4.a843c560.png";